import {Validators} from '@angular/forms';

import {FilterControl, Helper, SelectControl} from 'appShared/classes';
import {ComponentTypesEnum} from 'appShared/enums/common';
import {BaseControl} from 'appShared/classes/controls';
import {ReportTableColumn, ReportTableConfigInterface, ReportTableData} from 'appShared/components/report-table';
import {
    ClientStatusesEnum,
    ConstraintsCollection,
    ReportFilterConstraintsEnum,
    SubscriptionHistoryFilterModel,
    SubscriptionHistroyEventTypesEnum,
    UserCategoryTypesEnum
} from '@spa/api';
import {Pagination} from 'appShared/components';
import {TradingGroupClientTypesEnum} from 'appEntries/panel/enums';
import {InArrayValidator} from '@spa/validators';

export const FeedSubscriptionLogStorageId = 'FeedSubscriptionLogComponent';

export const FeedSubscriptionHistoryDateTimeSelector = 'FeedSubscriptionHistoryDateTime';

export const FeedSubscriptionHistoryClientSelector = 'FeedSubscriptionHistoryClient';
export const FeedSubscriptionHistoryUserSelector = 'FeedSubscriptionHistoryUser';
export const FeedSubscriptionHistoryClientTypeSelector = 'FeedSubscriptionHistoryClientType';
export const FeedSubscriptionHistoryAccountSelector = 'FeedSubscriptionHistoryAccount';
export const FeedSubscriptionHistoryBundleSelector = 'FeedSubscriptionHistoryBundle';
export const FeedSubscriptionHistoryPlatformSelector = 'FeedSubscriptionHistoryPlatform';
export const FeedSubscriptionHistoryEventSelector = 'FeedSubscriptionHistoryEvent';
export const FeedSubscriptionHistoryDateFromSelector = 'FeedSubscriptionHistoryDateFrom';
export const FeedSubscriptionHistoryDateToSelector = 'FeedSubscriptionHistoryDateTo';

export const FeedSubscriptionHistoryClientTypeIdFilterKey = 'subscription.clientTypeId';
export const FeedSubscriptionHistoryClientTypeFilterKey = 'subscription.clientType';
export const FeedSubscriptionHistoryClientIdFilterKey = 'subscription.clientId';
export const FeedSubscriptionHistoryAccountIdFilterKey = 'subscription.accountId';
export const FeedSubscriptionHistoryUserIdFilterKey = 'subscription.userId';
export const FeedSubscriptionHistoryBundleIdFilterKey = 'subscription.bundle.id';
export const FeedSubscriptionHistoryTradingPlatformIdFilterKey = 'subscription.bundle.platformFrontend.platformId';

export const FeedSubscriptionHistorySearchMinLength = 3;

export const FeedSubscriptionHistoryBundleName = 'Feed/Bundle';
export const FeedSubscriptionHistoryAccountName = 'Account';
export const FeedSubscriptionHistoryUserName = 'User';
export const FeedSubscriptionHistoryClientType = 'Client Type';
export const FeedSubscriptionHistoryClientName = 'Client';
export const FeedSubscriptionHistoryEventName = 'Event';
export const FeedSubscriptionHistoryDateName = 'Date';
export const FeedSubscriptionHistoryPlatformName = 'Platform';

export const defaultSubscriptionHistoryInitialFilterModel = (itemsPerPage = Pagination.defaultItemsPerPage) => {
    const filterModel = new SubscriptionHistoryFilterModel(
        new ConstraintsCollection(),
        Pagination.defaultPagesChunk - 1,
        SubscriptionHistoryFilterModel.getDateTimeSelector(),
        Pagination.calculateItemsPerPagesChunk(itemsPerPage),
        false
    );

    filterModel.addConstraintItem(
        ReportFilterConstraintsEnum.NotEqual,
        FeedSubscriptionHistoryClientTypeIdFilterKey,
        UserCategoryTypesEnum.Service
    );

    return filterModel;
};

export const FeedSubscriptionLogFilterControls = (hasUserView: boolean): FilterControl[] => {
    return [
        new FilterControl({
            name: FeedSubscriptionHistoryClientTypeSelector,
            placeholder: FeedSubscriptionHistoryClientType,
            controls: [
                new SelectControl({
                    name: FeedSubscriptionHistoryClientTypeSelector,
                    value: null,
                    placeholder: FeedSubscriptionHistoryClientType,
                    validators: [InArrayValidator([
                        TradingGroupClientTypesEnum.Individual,
                        TradingGroupClientTypesEnum.Company
                    ])],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.Individual),
                            value: TradingGroupClientTypesEnum.Individual
                        },
                        {
                            label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.Company),
                            value: TradingGroupClientTypesEnum.Company
                        }
                    ],
                    disabled: !hasUserView
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryClientSelector,
            placeholder: FeedSubscriptionHistoryClientName,
            controls: [
                new BaseControl({
                    name: FeedSubscriptionHistoryClientSelector,
                    value: null,
                    placeholder: FeedSubscriptionHistoryClientName,
                    validators: [Validators.minLength(FeedSubscriptionHistorySearchMinLength)],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryUserSelector,
            placeholder: FeedSubscriptionHistoryUserName,
            controls: [
                new BaseControl({
                    name: FeedSubscriptionHistoryUserSelector,
                    value: null,
                    placeholder: FeedSubscriptionHistoryUserName,
                    validators: [Validators.minLength(FeedSubscriptionHistorySearchMinLength)],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryAccountSelector,
            placeholder: FeedSubscriptionHistoryAccountName,
            controls: [
                new BaseControl({
                    name: FeedSubscriptionHistoryAccountSelector,
                    value: null,
                    placeholder: FeedSubscriptionHistoryAccountName,
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryBundleSelector,
            placeholder: FeedSubscriptionHistoryBundleName,
            controls: [
                new SelectControl({
                    name: FeedSubscriptionHistoryBundleSelector,
                    value: ClientStatusesEnum.All,
                    placeholder: FeedSubscriptionHistoryBundleName,
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [],
                    multiple: true
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryPlatformSelector,
            placeholder: FeedSubscriptionHistoryPlatformName,
            controls: [
                new SelectControl({
                    name: FeedSubscriptionHistoryPlatformSelector,
                    value: null,
                    placeholder: FeedSubscriptionHistoryPlatformName,
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [],
                    multiple: true
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryEventSelector,
            placeholder: FeedSubscriptionHistoryEventName,
            controls: [
                new SelectControl({
                    name: FeedSubscriptionHistoryEventSelector,
                    value: null,
                    placeholder: FeedSubscriptionHistoryEventName,
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: Object.values(SubscriptionHistroyEventTypesEnum).map((key: string) => {
                        return {
                            label: Helper.textsHelper().getMarketDataHistoryEventName(key),
                            value: key
                        };
                    }),
                    multiple: true
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
        new FilterControl({
            name: FeedSubscriptionHistoryDateName,
            placeholder: FeedSubscriptionHistoryDateName,
            controls: [
                new BaseControl({
                    name: FeedSubscriptionHistoryDateFromSelector,
                    value: null,
                    placeholder: 'Date From',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: FeedSubscriptionHistoryDateToSelector,
                    value: null,
                    placeholder: 'Date To',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 0,
            shown: true,
            isRemovable: false
        }),
    ];
};

export const FeedSubscriptionLogDataTableItems = (
    hasClientView: boolean,
    hasUserView: boolean,
    hasAccountView: boolean,
    hasBundleView: boolean,
    hasAssignedFeedView: boolean,
    hasPlatformView: boolean
): ReportTableData[] => {
    const items = [
        new ReportTableData<number>({
            colId: FeedSubscriptionHistoryDateTimeSelector,
            value: null,
            hidden: false

        }),
    ];

    if (hasBundleView) {
        items.push(new ReportTableData<number>({
                colId: FeedSubscriptionHistoryBundleSelector,
                value: null,
                hidden: false

            })
        );
    }

    if (hasBundleView && hasPlatformView) {
        items.push(new ReportTableData<number>({
                colId: FeedSubscriptionHistoryPlatformSelector,
                value: null,
                hidden: false
            })
        );
    }

    if (hasAssignedFeedView && hasUserView && hasClientView) {
        items.push(
            new ReportTableData<number>({
                colId: FeedSubscriptionHistoryUserSelector,
                value: null,
                hidden: false

            })
        );
    }

    if (hasAssignedFeedView && hasAccountView) {
        items.push(
            new ReportTableData<number>({
                colId: FeedSubscriptionHistoryAccountSelector,
                value: null,
                hidden: false

            })
        );
    }

    items.push(
        new ReportTableData<number>({
            colId: FeedSubscriptionHistoryEventSelector,
            value: null,
            hidden: false
        })
    );

    return items;
};

export const FeedSubscriptionLogDataTableConfig = (
    hasClientView: boolean,
    hasUserView: boolean,
    hasAccountView: boolean,
    hasBundleView: boolean,
    hasAssignedFeedView: boolean,
    hasPlatformView: boolean
): ReportTableConfigInterface => {

    const columns = [
        new ReportTableColumn({
            label: FeedSubscriptionHistoryDateName,
            selector: FeedSubscriptionHistoryDateTimeSelector
        }),
    ];

    if (hasBundleView) {
        columns.push(new ReportTableColumn({
            label: FeedSubscriptionHistoryBundleName,
            selector: FeedSubscriptionHistoryBundleSelector
        }));
    }

    if (hasBundleView && hasPlatformView) {
        columns.push(new ReportTableColumn({
            label: FeedSubscriptionHistoryPlatformName,
            selector: FeedSubscriptionHistoryPlatformSelector
        }));
    }

    if (hasAssignedFeedView && hasUserView && hasClientView) {
        columns.push(new ReportTableColumn({
            label: FeedSubscriptionHistoryUserName,
            selector: FeedSubscriptionHistoryUserSelector
        }));
    }

    if (hasAssignedFeedView && hasAccountView) {
        columns.push(new ReportTableColumn({
            label: FeedSubscriptionHistoryAccountName,
            selector: FeedSubscriptionHistoryAccountSelector
        }));
    }

    columns.push(new ReportTableColumn({
        label: FeedSubscriptionHistoryEventName,
        selector: FeedSubscriptionHistoryEventSelector
    }));

    return {
        rows: [],
        columns,
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true
    };
};

